import { IconButton, makeStyles } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import clsx from 'clsx';
import { CSSProperties, FC, MouseEventHandler } from 'react';

interface Props {
  className?: string;
  onClear: MouseEventHandler<HTMLButtonElement> | undefined;
  style?: CSSProperties;
}

const useStyles = makeStyles(() => ({
  iconButton: {
    visibility: 'hidden',
    pointerEvents: 'none',
  },
}));

export const ClearButton: FC<Props> = ({ className, onClear, style }) => {
  const classes = useStyles();
  return (
    <IconButton
      style={style}
      className={clsx(classes.iconButton, className)}
      size="small"
      onClick={onClear}
      aria-label="clear"
    >
      <ClearIcon fontSize="inherit" />
    </IconButton>
  );
};
